// the whole state will be sent to api
export default {
	state: {
		overviewImage: null,
		vehicleKilometrage: null,
		customer: null,
		vehicle: null,
		damageAssessor: null,
		insurance: null,
		accident: null,
		oppositeInsuranceState: null,
		opposite_case_number: null,
		opposite_insurance_contract_number: null,
		repairOrder: null,
		signLocation: null,
		customerConsultantSign: null,
		customerRepairOrderSign: null,
		has_appraisal: null,
		has_cost_estimation: null,
		estimation_company: null,
		date_cost_estimation: null
	},
	getters: {
		getProcessCreateComprehensive(state) {
			return state;
		},
	},
	mutations: {
		setProcessCreateCustomerRepairOrderSign(state, payload) {
			state.customerRepairOrderSign = payload;
		},
		setProcessCreateCustomerConsultantSign(state, payload) {
			state.customerConsultantSign = payload;
		},
		setProcessCreateComprehensiveSignLocation(state, payload) {
			state.signLocation = payload;
		},
		setProcessCreateComprehensiveRepairOrder(state, payload) {
			state.repairOrder = payload;
		},
		setProcessCreateComprehensiveOppositeInsuranceState(state, payload) {
			state.oppositeInsuranceState = payload;
		},
		setProcessCreateComprehensiveOppositeCaseNumber(state, payload) {
			state.opposite_case_number = payload;
		},
		setProcessCreateComprehensiveOppositeInsuranceContractNumber(state, payload) {
			state.opposite_insurance_contract_number = payload;
		},
		setProcessCreateComprehensiveAccident(state, payload) {
			state.accident = payload;
		},
		setProcessCreateComprehensiveInsurance(state, payload) {
			state.insurance = payload;
		},
		setProcessCreateComprehensiveCustomer(state, payload) {
			state.customer = payload;
		},
		setProcessCreateComprehensiveVehicle(state, payload) {
			state.vehicle = payload;
		},
		setProcessCreateComprehensiveOverviewImage(state, payload) {
			state.overviewImage = payload;
		},
		setProcessCreateComprehensiveAppraisal(state, payload) {
			state.has_appraisal = payload;
		},
		setProcessCreateComprehensiveCostEstimation(state, payload) {
			state.has_cost_estimation = payload;
		},
		setProcessCreateComprehensiveEstimationCompany(state, payload) {
			state.estimation_company = payload;
		},
		setProcessCreateComprehensiveDateCostEstimation(state, payload) {
			state.date_cost_estimation = payload;
		},
		setProcessCreateComprehensiveVehicleKilometrage(state, payload) {
			state.vehicleKilometrage = payload;
		},
		clearProcessCreateComprehensive(state) {
			for (const [key, value] of Object.entries(state)) {
				state[key] = null;
			}
		},
	},
	actions: {},
};
